import { render, staticRenderFns } from "./electron.vue?vue&type=template&id=2985b26d&scoped=true"
import script from "./electron.vue?vue&type=script&lang=js"
export * from "./electron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2985b26d",
  null
  
)

export default component.exports